export enum Roles {
  ADMIN= 'unimagen-admin',
  USER = 'unimagen-employee',
  SENIAT = 'unimagen-seniat',
  ANY = 'any'
}
